module.exports = __webpack_public_path__ + "img/122.a399138e.png";